<template>
 <div class="new-email">
   <div class="container-fluid">
     <sidebar />
     <div class="col-md-9 col-lg-10 ml-md-auto">
       <div id="scroll" class="header d-flex justify-content-start w-100 align-items-center py-3 mb-5 border-bottom border-dark">
         <h2 class="my-3">新規メッセージを作成</h2>
       </div>
       <div class="validation py-3 px-5 my-4" v-if="errors.length">
         <div v-for="(error, index) in errors" :key="index">
          <p class="m-0">{{error}}</p>
         </div>
       </div>
       <div v-if="emailStatus">
        {{statusAlert(true)}}
       </div>
       <div class="main-bg py-3 px-2 mb-4 mb-2 bg-light text-dark">
         <b-container fluid>
           <b-form>
            <div v-if="allMember">
              <b-row class="mx-2 mb-4 border border-dark">
                <b-col lg="12" class="bg-light border-right border-dark">
                  <div class="form-header align-items-center d-flex px-5 py-4">
                    <label class="mr-5 mb-0">宛先</label>
                    <span class="w-50 mr-2">
                      <b-form-select v-model="destinations" :options="destination" class="form-select ml-1 border-right-0 rounded-0"></b-form-select>
                    </span>
                    <b-button v-b-modal.modal-center class="px-5 pull-right" variant="primary" :disabled="isDisabled()">リストを表示</b-button>
                  </div>
                  <b-form-group v-if="destinations !== 'unselected'" class="form-radio-button">
                    <div class="col-10 ml-auto pl-0">
                      <input v-model="usersDestination" type="radio" id="ok" value="ok">
                      <label class="mr-4 ml-2" for="ok" >OKユーザーのみ</label>
                      <input v-model="usersDestination" type="radio" id="all" value="all">
                      <label class="mr-4 ml-2" for="all" >NGユーザーを含む</label>
                      <input v-model="usersDestination" type="radio" id="ng" value="ng">
                      <label class="mr-4 ml-2" for="ng">NGユーザーのみ</label>
                    </div>
                  </b-form-group>
                  <details class="px-5 py-4">
                    <summary>{{ selectedTargets.length }}人が宛先に含まれています</summary>
                    <ul class="list-inline">
                      <li class="list-inline-item" v-for="target in selectedTargets" :key="target.id"><span class="badge badge-info">{{ target.memberinfo.fullname }}</span></li>
                    </ul>
                  </details>
                </b-col>
              </b-row>
            <b-modal id="modal-center" ref="modal-center" size="huge" centered :hide-footer="true" :hide-header="true" title="BootstrapVue">
              <b-container fluid>
                  <div class="select-content mb-4">
                    <div class="container">
                      <b-row>
                        <b-col lg="2">
                          <b-form-input v-model="memberFilters.fullname" placeholder="氏名"></b-form-input>
                        </b-col>
                        <b-col lg="2">
                          <b-form-select v-model="memberFilters.country" @change="changeCountry">
                            <b-form-select-option :value="null">国名</b-form-select-option>
                            <b-form-select-option v-for="(country, index) in countries" :key="index" :value="country">{{country}}</b-form-select-option>
                          </b-form-select>
                        </b-col>
                        <b-col lg="2">
                          <b-form-select v-model="memberFilters.prefecture" :disabled="memberFilters.country !== 'Japan'">
                            <b-form-select-option :value="null">都道府県</b-form-select-option>
                            <b-form-select-option v-for="(prefecture, index) in prefectures" :key="index" :value="prefecture">{{prefecture}}</b-form-select-option>
                          </b-form-select>
                        </b-col>
                        <b-col lg="2">
                          <b-form-select v-model="memberFilters.age" class="form-select">
                            <b-form-select-option :value="null" disabled="disabled" selected>年齢</b-form-select-option>
                            <b-form-select-option v-for="(item, index) in ageSetup" :key="index" :value="item">{{item + $t('exts')}}</b-form-select-option>
                          </b-form-select>
                        </b-col>
                        <b-col lg="2">
                          <b-form-select v-model="memberFilters.gender">
                            <b-form-select-option :value="null">性別</b-form-select-option>
                            <b-form-select-option value="Male">男性</b-form-select-option>
                            <b-form-select-option value="Female">女性</b-form-select-option>
                          </b-form-select>
                        </b-col>
                        <b-col lg="2">
                          <b-form-select v-model="memberFilters.property_use" :options="property_use"></b-form-select>
                        </b-col>
                      </b-row>
                      <b-row class="mt-2">
                        <b-col lg="2">
                          <b-form-select v-model="memberFilters.property_types" :options="property_types"></b-form-select>
                        </b-col>
                        <b-col lg="2">
                          <b-form-select v-model="memberFilters.price_range" :options="price"></b-form-select>
                        </b-col>
                        <b-col lg="2">
                          <b-form-select v-model="memberFilters.business_types" :options="business_types"></b-form-select>
                        </b-col>
                        <b-col lg="2">
                          <b-form-select v-model="memberFilters.area">
                            <b-form-select-option :value="null">エリア</b-form-select-option>
                            <b-form-select-option v-for="(prefecture, index) in prefectures" :key="index" :value="prefecture">{{prefecture}}</b-form-select-option>
                          </b-form-select>
                        </b-col>
                        <b-col lg="2">
                          <b-form-select v-model="memberFilters.plan">
                            <b-form-select-option v-for="(plan, index) in plans" :key="index" :value="plan.value">{{plan.text}}</b-form-select-option>
                          </b-form-select>
                        </b-col>
                        <b-col lg="2">
                          <b-form-select v-model="memberFilters.languages">
                            <b-form-select-option :value="null">言語</b-form-select-option>
                            <b-form-select-option v-for="(language) in languages" :key="language" :value="language">{{$t(language)}}</b-form-select-option>
                          </b-form-select>
                        </b-col>
                      </b-row>
                      <b-row class="mt-2">
                        <b-col lg="2">
                          <b-form-select v-model="memberFilters.email">
                            <b-form-select-option :value="null">メッセージ</b-form-select-option>
                            <b-form-select-option value="ok">OK</b-form-select-option>
                            <b-form-select-option value="ng">NG</b-form-select-option>
                          </b-form-select>
                        </b-col>
                        <b-col lg="2">
                          <b-form-select v-model="memberFilters.memberRegistrationDate" :options="memberRegistrationDateOptions"></b-form-select>
                        </b-col>
                        <b-col lg="2">
                          <b-button class="w-100" variant="success" @click="filterReset">リセット</b-button>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                <div class="responsive-table">
                    <b-table sticky-header="600px" id="my-table" head-variant="light" bordered responsive
                      :items="filteredPeople"
                      :fields="fields"
                      hover
                    >
                      <template #cell(selected)="row">
                          <b-form-checkbox size="lg" v-model="selected" :value="row.item"/>
                      </template>
                      <template #head(selected)="">
                          <b-form-checkbox size="lg" v-model="selectAll" @change="select"><span></span></b-form-checkbox>
                      </template>
                      <template #cell(memberinfo.fullname)="row">
                          <router-link class="text-dark" :to="'/administrator/edit-member/' + row.item.id"> {{ row.value }}</router-link>
                      </template>
                      <template #head(memberinfo.countryAndPrefecture)="">
                        国名<br>都道府県
                      </template>
                      <template #cell(memberinfo.countryAndPrefecture)="row">
                          {{ row.item.memberinfo.country }}<br>
                          {{ row.item.memberinfo.prefectures }}
                      </template>
                      <template #head(memberinfo.properties)="">
                        物件用途<br>検討物件
                      </template>
                      <template #cell(memberinfo.properties)="row">
                          {{ $i18n.t(row.item.memberinfo.use_of_the_property) }}<br>
                          {{ row.item.memberinfo.types_of_properties }}
                      </template>
                      <template #cell(memberinfo.business_type)="row">
                          <span v-if="row.item.memberinfo.business_type_developer">{{ $i18n.t('business_type_developer') }}<br></span>
                          <span v-if="row.item.memberinfo.business_type_mediator">{{ $i18n.t('business_type_mediator') }}<br></span>
                          <span v-if="row.item.memberinfo.business_type_indivisual">{{ $i18n.t('business_type_indivisual') }}</span>
                      </template>
                      <template #cell(memberinfo.plan)="row">
                        {{ planName(row) }}
                      </template>
                    </b-table>
                </div>
                <div class="d-flex justify-content-start align-items-center mt-4">
                  <b-button class="py-3 px-5 mr-3" variant="primary" @click="cancelModal()">キャンセル</b-button>
                  <b-button class="py-3 px-5" variant="success" @click="hideModal()">決定</b-button>
                </div>
              </b-container>
            </b-modal>
            </div>
             <b-form-group label="件名" id="sbject" class="mb-4 required">
              <b-col class="p-0">
                <b-form-input class="form-input" :state="validation.subject" v-model="subject"></b-form-input>
                <b-form-invalid-feedback :state="validation.subject">
                    件名は必須です
                </b-form-invalid-feedback>
              </b-col>
             </b-form-group>

             <b-form-group label="メルマガ本文" id="blog-body">
                <Editor v-model="body" :api-key="getTinyConfig.api_key"  :init="getTinyConfig.config"/>
              </b-form-group>
           </b-form>
        </b-container>
       </div>
       <div class="d-flex justify-content-start align-items-center mb-4">
         <a href="#scroll" class="text-decoration-none text-white" v-smooth-scroll><b-button class="py-3 px-5 mr-3" variant="primary" @click="draft">下書きとして保存</b-button></a>
         <a href="#scroll" class="text-decoration-none text-white" v-smooth-scroll><b-button class="py-3 px-5" variant="success" @click="save">送信</b-button></a>
       </div>
     </div>
   </div>
 </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import sidebar from '@/components/_sidebar/sidebar'
import appConfig from '../../api/api'
import { languages, memberAges, businessPropertyValues, propertyUses, propertyPrices } from '../../assets/data/values'
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      body: null,
      subject: null,
      usersDestination: 'ok',
      destination_id: [],
      errors: [],
      response: null,
      validation: {
        subject: null
      },
      property_use: [{ text: '物件用途' }].concat(propertyUses.map(u => { return { value: u, text: this.$i18n.t(u) } })),
      property_types: [{ text: '検討物件' }].concat(Object.values(businessPropertyValues.propertyTypes).flat().map(t => this.$i18n.t(t))),
      price: [{ text: '価格帯' }].concat(propertyPrices.map(p => { return { value: p, text: this.$i18n.t(p) } })),
      business_types: [
        { value: null, text: '業種' },
        { value: 'business_type_indivisual', text: '個人' },
        { value: 'business_type_developer', text: '物件デベロッパー' },
        { value: 'business_type_mediator', text: '物件仲介' }
      ],
      plans: [
        { value: null, text: 'プラン' },
        { value: 'free', text: '無料プラン' },
        { value: 'set_plan_platinum', text: 'セットプラン（プラチナ）' },
        { value: 'set_plan_gold', text: 'セットプラン（ゴールド）' },
        { value: 'set_plan_silver', text: 'セットプラン（シルバー）' },
        { value: 'single_plan_lite', text: '個別プラン（ライト）' },
        { value: 'single_plan_basic', text: '個別プラン（ベーシック）' },
        { value: 'single_plan_business', text: '個別プラン（ビジネス）' },
        { value: 'single_plan_expoert', text: '個別プラン（エキスパート）' }
      ],
      destinations: null,
      users: 'all',
      userLanguage: [
        { text: 'NGユーザーを含む', value: 'all' },
        { text: 'NGユーザーのみ', value: 'ng' }
      ],
      languages: languages,
      destination: [
        { value: null, text: '選択して下さい', disabled: true }
      ].concat(['unselected'].concat(languages).map((value) => {
        return { value: value, text: this.$i18n.t(`email-target:${value}`) }
      })),
      ageSetup: memberAges,
      fields: [
        { key: 'selected', thStyle: { background: '#F8F9FA' } },
        { key: 'memberinfo.fullname', label: '氏名', thStyle: { background: '#F8F9FA' } },
        { key: 'memberinfo.countryAndPrefecture', thStyle: { background: '#F8F9FA' } },
        { key: 'memberinfo.address', label: '住所', thStyle: { background: '#F8F9FA' } },
        { key: 'memberinfo.age', label: '年齢', thStyle: { background: '#F8F9FA' } },
        {
          key: 'memberinfo.gender',
          label: '性別',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return this.$i18n.t(value.toLowerCase())
          }
        },
        {
          key: 'memberinfo.properties',
          thStyle: { background: '#F8F9FA' }
        },
        {
          key: 'memberinfo.desired_price_range',
          label: '価格帯',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return this.$i18n.t(value)
          }
        },
        {
          key: 'memberinfo.business_type',
          label: '業種',
          thStyle: { background: '#F8F9FA' }
        },
        {
          key: 'memberinfo.area',
          label: 'エリア',
          thStyle: { background: '#F8F9FA' }
        },
        {
          key: 'memberinfo.plan',
          label: 'プラン',
          thStyle: { background: '#F8F9FA' }
        },
        {
          key: 'memberinfo.language',
          label: '言語',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return this.$i18n.t(value)
          }
        },
        {
          key: 'memberinfo.email_magazine_delivery',
          label: 'メッセージ',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            if (value) {
              return value.toUpperCase()
            }
          }
        },
        {
          key: 'created_at',
          label: '会員登録日',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return value.substring(0, 10)
          }
        }
      ],
      memberFilters: {
        fullname: null,
        age: null,
        gender: null,
        email: null,
        country: null,
        prefecture: null,
        languages: null,
        property_types: null,
        consider_purchasing: null,
        price_range: null,
        purchase: null,
        property_use: null,
        business_types: null,
        area: null,
        plan: null,
        memberRegistrationDate: null
      },
      selectAll: false,
      selected: [],
      selectedPeople: null
    }
  },
  components: {
    sidebar,
    Editor
  },
  computed: {
    ...mapState('adminAddMember', ['prefectures', 'countries']),
    ...mapState('latestMember', ['allMember', 'memberRegistrationDates']),
    ...mapState('adminMagazine', ['emailStatus', 'members']),
    memberRegistrationDateOptions: function () {
      return [{ value: null, text: '会員登録年月' }].concat(this.memberRegistrationDates.map(d => ({ value: d.replaceAll('/', '-'), text: d.replace('/', '年') + '月' })))
    },
    getTinyConfig: function () {
      return appConfig
    },
    filteredPeople: function () {
      return this.allMember.data
        .filter(this.filterByFullname)
        .filter(this.filterByGender)
        .filter(this.filterByEmail)
        .filter(this.filterByAge)
        .filter(this.filterByLanguages)
        .filter(this.filterByCountry)
        .filter(this.filterByPrefecture)
        .filter(this.filterByPropertyUse)
        .filter(this.filterByPropertyType)
        .filter(this.filterByConsideration)
        .filter(this.filterByPrice)
        .filter(this.filterByBusinessType)
        .filter(this.filterByArea)
        .filter(this.filterByPlan)
        .filter(this.filterByMemberRegistrationDate)
    },
    destinationCount: function () {
      return this.allMember.data
        .filter(this.filterDestination)
        .filter(this.filterByEmailSubscription)
    },
    selectedTargets: function () {
      if (this.destinationCount.length !== 0) {
        return this.destinationCount
      } else if (this.selected.length !== 0) {
        return this.selected
      } else {
        return []
      }
    }
  },
  created () {
    this.getAllMember()
    this.prefectureCountry()
    this.$store.commit('adminMagazine/setEmailStatus', null)
    this.memberCheck()
    this.fromMemberlist()
    this.getMemberRegistrationDates()
  },
  methods: {
    ...mapActions('adminAddMember', ['prefectureCountry']),
    ...mapActions('latestMember', ['getAllMember', 'getMemberRegistrationDates']),
    ...mapActions('adminMagazine', ['addMagazine']),
    memberCheck () {
      if (this.allMember) {
        if (this.members.length === this.allMember.data.length) {
          this.selectAll = true
        }
      }
    },
    save: function () {
      this.errors = []
      this.validation.subject = !!this.subject
      const dataIsValid = this.validation.subject
      if (dataIsValid) {
        if (this.destinations === 'unselected') {
          this.destination_id = []
          let n = 0
          while (n !== this.selected.length) {
            this.destination_id.push(this.selected[n])
            n++
          }
          const destinationID = this.destination_id.map(el => [
            el.id
          ])
          const value = {
            destination_id: [destinationID],
            language: this.destinations,
            accept_magazines: this.usersDestination,
            subject: this.subject,
            body: this.body,
            published_status: 'sent',
            selected_ng: 'all'
          }
          this.addMagazine(value)
          this.destinations = null
          this.usersDestination = null
          this.subject = null
          this.body = ''
          this.usersDestination = 'ok'
          this.selected = []
        } else {
          const value = {
            language: this.destinations,
            accept_magazines: this.usersDestination,
            subject: this.subject,
            body: this.body,
            published_status: 'sent',
            selected_ng: this.usersDestination
          }
          this.addMagazine(value)
          this.destinationID = null
          this.destinations = null
          this.usersDestination = null
          this.subject = null
          this.body = ''
          this.usersDestination = 'ok'
          this.selected = []
        }
      } else {
        this.errors.push('エラー：すべてのフィールドを確認して、再試行してください')
      }
    },
    draft: function () {
      this.errors = []
      this.validation.subject = !!this.subject
      const dataIsValid = this.validation.subject
      if (dataIsValid) {
        if (this.destinations === 'unselected') {
          this.destination_id = []
          let n = 0
          while (n !== this.selected.length) {
            this.destination_id.push(this.selected[n])
            n++
          }
          const destinationID = this.destination_id.map(el => [
            el.id
          ])
          const value = {
            destination_id: [destinationID],
            language: this.destinations,
            accept_magazines: this.usersDestination,
            subject: this.subject,
            body: this.body,
            published_status: 'draft',
            selected_ng: 'all'
          }
          this.addMagazine(value)
          this.destinations = null
          this.usersDestination = null
          this.subject = null
          this.body = ''
          this.usersDestination = 'ok'
          this.selected = []
        } else {
          const value = {
            language: this.destinations,
            accept_magazines: this.usersDestination,
            subject: this.subject,
            body: this.body,
            published_status: 'draft',
            selected_ng: this.usersDestination
          }
          this.addMagazine(value)
          this.destinationID = null
          this.destinations = null
          this.usersDestination = null
          this.subject = null
          this.body = ''
          this.usersDestination = 'ok'
          this.selected = []
        }
      } else {
        this.errors.push('エラー：すべてのフィールドを確認して、再試行してください')
      }
    },
    select () {
      this.selected = []
      if (!this.selectAll) {
        for (const row in this.allMember.data) {
          this.selected.push(this.allMember.data[row])
        }
      }
    },
    isDisabled () {
      if (this.destinations !== 'unselected') {
        return true
      }
    },
    filterByAge: function (member) {
      if (this.memberFilters.age === null || this.memberFilters.age === '') {
        return true
      }
      return (member.memberinfo.age === Number(this.memberFilters.age))
    },
    filterByGender: function (member) {
      if (this.memberFilters.gender === null) {
        return true
      }
      return (member.memberinfo.gender === this.memberFilters.gender)
    },
    filterByEmail: function (member) {
      if (this.memberFilters.email === null) {
        return true
      }
      return (member.memberinfo.email_magazine_delivery === this.memberFilters.email)
    },
    filterByLanguages: function (member) {
      if (this.memberFilters.languages === null) {
        return true
      }
      return (member.memberinfo.language === this.memberFilters.languages)
    },
    filterByPropertyUse: function (member) {
      if (this.memberFilters.property_use === null) {
        return true
      }
      return (member.memberinfo.use_of_the_property === this.memberFilters.property_use)
    },
    filterByPrefecture: function (member) {
      if (this.memberFilters.prefecture === null) {
        return true
      }
      return (member.memberinfo.prefectures === this.memberFilters.prefecture)
    },
    filterByCountry: function (member) {
      if (this.memberFilters.country === null) {
        return true
      }
      return (member.memberinfo.country === this.memberFilters.country)
    },
    filterByConsideration: function (member) {
      if (this.memberFilters.consider_purchasing === null) {
        return true
      }
      return (member.memberinfo.when_to_consider_purchasing === this.memberFilters.consider_purchasing)
    },
    filterByPrice: function (member) {
      if (this.memberFilters.price_range === null) {
        return true
      }
      return (member.memberinfo.desired_price_range === this.memberFilters.price_range)
    },
    filterByPropertyType: function (member) {
      if (this.memberFilters.property_types === null) {
        return true
      }
      return (member.memberinfo.types_of_properties === this.memberFilters.property_types)
    },
    filterDestination: function (member) {
      if (member.memberinfo !== null) {
        if (this.destinations === null) {
          return (member.memberinfo.language === 'unselected')
        }
        switch (this.destinations) {
          case 'Japanese':
            return (member.memberinfo.language === 'Japanese')
          case 'English':
            return (member.memberinfo.language === 'English')
          case 'Simplified Chinese':
            return (member.memberinfo.language === 'Simplified Chinese')
          case 'Traditional Chinese':
            return (member.memberinfo.language === 'Traditional Chinese')
          default:
            return (member.memberinfo.language === 'unselected')
        }
      }
    },
    filterByEmailSubscription: function (member) {
      if (this.usersDestination === null) {
        return true
      }
      switch (this.usersDestination) {
        case 'all':
          return true
        case 'ng':
          return (member.memberinfo.email_magazine_delivery === 'ng')
        case 'ok':
          return (member.memberinfo.email_magazine_delivery === 'ok')
      }
    },
    filterByFullname: function (member) {
      const filterFullname = this.memberFilters.fullname
      if (!filterFullname) {
        return true
      }
      return member.memberinfo.fullname.indexOf(filterFullname) > -1
    },
    filterByBusinessType: function (member) {
      if (this.memberFilters.business_types === 'business_type_indivisual') {
        return member.memberinfo.business_type_indivisual
      } else if (this.memberFilters.business_types === 'business_type_developer') {
        return member.memberinfo.business_type_developer
      } else if (this.memberFilters.business_types === 'business_type_mediator') {
        return member.memberinfo.business_type_mediator
      }
      return true
    },
    filterByArea: function (member) {
      if (this.memberFilters.area === null) {
        return true
      }
      return member.memberinfo.area === this.memberFilters.area
    },
    filterByPlan: function (member) {
      // 検索条件が未選択
      if (this.memberFilters.plan === null) {
        return true
      }

      // 無料プランで検索
      if (this.memberFilters.plan === 'free') {
        return member.contracts.length === 0
      }

      if (member.contracts.length > 0) {
        // lookup_keyには"set_plan_gold_ja"のような言語情報がついているので、
        // startsWithで検索すれば言語を問わずに検索ができる
        return member.contracts[0].price.lookup_key.startsWith(this.memberFilters.plan)
      }

      return false
    },
    filterByMemberRegistrationDate: function (member) {
      if (this.memberFilters.memberRegistrationDate === null) {
        return true
      }
      return (member.created_at.startsWith(this.memberFilters.memberRegistrationDate))
    },
    hideModal () {
      this.$refs['modal-center'].hide()
    },
    cancelModal () {
      this.selected = []
      this.$refs['modal-center'].hide()
    },
    fromMemberlist: function () {
      if (this.members.length !== 0) {
        this.destinations = 'unselected'
        this.selected = this.members
      }
    },
    statusAlert (append = false) {
      this.$bvToast.toast('body', {
        title: this.emailStatus,
        toaster: 'b-toaster-top-center',
        solid: true,
        appendToast: append,
        autoHideDelay: 3000
      })
    },
    filterReset () {
      this.memberFilters = {
        age: null,
        gender: null,
        email: null,
        country: null,
        prefecture: null,
        languages: null,
        property_types: null,
        consider_purchasing: null,
        price_range: null,
        purchase: null,
        property_use: null,
        fullname: null,
        business_types: null,
        area: null,
        plan: null,
        memberRegistrationDate: null
      }
    },
    changeCountry () {
      if (this.memberFilters.country !== 'Japan') {
        this.memberFilters.prefecture = null
      }
    },
    planName (row) {
      if (row.item.privileged) {
        return 'リード社プラン'
      }
      return row.item.contracts[0] ? row.item.contracts[0].price.product.name : ''
    }
  }
}
</script>
